import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SnotifyService } from "ng-snotify";
import { CompanyService } from "../../../../services/company.service";
import { EngineerService } from "../../../../services/engineer.service";
import { LocationService } from "../../../../services/location.service";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "../../../../services/auth.service";
import { UUID } from "angular2-uuid";



@Component({
  selector: 'app-engineers-manage',
  templateUrl: './engineers-manage.component.html',
  styleUrls: ['./engineers-manage.component.scss']
})
export class EngineersManageComponent implements OnInit {

  id: string;

  firstname: string = "";
  surname: string = "";
  credentials: string = "";

  password: string = "";
  password2: string = "";
  userId: number = 0;
  selectedLocations: Location[];
  locationList: Location[];
  sig;
  imageSource;
  userids;
  user;
  isEdit: boolean = false;
  expired: boolean = false;
  constructor(private authService: AuthService,private sanitizer: DomSanitizer,private engineerService: EngineerService, private locationService: LocationService,
    private companyService: CompanyService,
    private router: Router, private route: ActivatedRoute, private snotifyService: SnotifyService) {
      this.user = this.authService.currentUser.value;
     }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramsMap) => {
      var id = paramsMap.get("id");
      ////console.log(id);
      if (id != null) {

        this.engineerService.get(id).then((user) => {
          //console.log(user);
          this.id = user.id;
          this.firstname = user.firstname;
          this.surname = user.surname;
          this.credentials = user.credentials;
          this.expired = user.expired;

       this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64,${user.signature}`);

          this.isEdit = true;
        });
      } else {
        this.isEdit = false;
      }
      ////console.log(this.isEdit);
    });
  }


  

  back() {
    this.router.navigate(['engineers']);
  }

  validate() {
    if (this.firstname == null || this.firstname == "") {
      this.snotifyService.error("Enter firstname");
      //alert("Enter firstname");
      return false;
    }
    if (this.surname == null || this.surname == "") {
      this.snotifyService.error("Enter surname");
      //alert("Enter firstname");
      return false;
    }



    if ((this.password == null || this.password == "") && (this.password2 != null && this.password2 != "")) {
      this.snotifyService.error("Enter password");
      //alert("Enter password");
      return false;
    }

    if ((this.password != null && this.password != "") && (this.password2 == null || this.password2 == "")) {
      this.snotifyService.error("Enter password");
      //alert("Enter password");
      return false;
    }

    if ((this.password != null && this.password != "") && (this.password2 != null && this.password2 != "") && (this.password != this.password2)) {
      this.snotifyService.error("Passwords do not match");
      //alert("Passwords do not match");
      return false;
    }


    return true;
  }

  async save() {
    if (!this.validate()) {
      return;
    }


    var user = {
      id: this.id == null || this.id == undefined ? UUID.UUID() : this.id,
      firstname: this.firstname,
      surname: this.surname,
      pin: this.password,
      last_Updated_By: this.user.id,
      base64Signature: this.sig
    };

//console.log(user);
    if (this.id == null)
      await this.engineerService.add(user);
    else
      await this.engineerService.update(user);

    this.router.navigate(['engineers']);
  }

  async delete() {
    await this.engineerService.delete(this.id);
    this.router.navigate(['engineers']);
  }

  uploadFile(files) {
    //console.log(files);
    const file = (files.target as HTMLInputElement).files[0];
    //console.log(file);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if(reader.result != null && reader.result != undefined){
        this.sig = reader.result;
       this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.sig}`);
                
      }
    };

  }

}
